import { z } from 'zod'

/**
 * A position in a newest-first log: the last row's time and id. Ties on time
 * are broken by id, so rows created in the same millisecond are never skipped
 * between pages. Serialized as `<ISO time>_<uuid>`.
 */
export interface PageCursor {
  createdAt: string
  id: string
}

const CURSOR = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)_([0-9a-f-]{36})$/i

export const pageCursorSchema = z.string().regex(CURSOR, 'Not a page cursor')

export function encodePageCursor(cursor: PageCursor): string {
  return `${cursor.createdAt}_${cursor.id}`
}

export function decodePageCursor(text: string): PageCursor | null {
  const match = CURSOR.exec(text)
  if (!match?.[1] || !match[2]) return null
  return { createdAt: match[1], id: match[2] }
}
